/* eslint-disable arrow-parens */
/* eslint-disable prettier/prettier */
import { useState, useEffect, useContext, useCallback, Suspense, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
	TextField,
	Paper,
	Grid,
	Button,
	Chip,
	Slider,
	Divider,
	withStyles,
	ButtonGroup,
	ClickAwayListener,
	Grow,
	Popper,
	Checkbox,
	MenuItem,
	Select,
	CheckboxProps
} from "@material-ui/core";
import { Autocomplete, SpeedDial, SpeedDialIcon, SpeedDialAction, Alert, AlertTitle } from "@material-ui/lab";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { SketchPicker } from "react-color";
import { green } from "@material-ui/core/colors";
import SnackbarAPICall from "../../../../shared/snackbar/SnackbarAPICall";
import { AuthContext, UIContext } from "../../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { api } from "../../../../../utils/api";
import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import { Validation } from "../../../../../@types/validation.types";
import { SnackbarProps } from "../../../../../@types/snackbarAPI.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useEmployerRoute, useQuery } from "../../../../../hooks";

import Tooltip from "@material-ui/core/Tooltip";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import SaveIcon from "@material-ui/icons/Save";
import PublishIcon from "@material-ui/icons/Publish";
import EventIcon from "@material-ui/icons/Event";

import "./editAnnouncements.css";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { dateTimeZoneConverter } from "../../../../../utils/commonFunctions/date";
import { downloadFileFromMongoDB } from "../../../../../utils/commonFunctions/downloadFileFromDatabase";

const PrettoSlider = withStyles({
	root: {
		color: "#52af77",
		height: 8
	},
	thumb: {
		height: 24,
		width: 24,
		backgroundColor: "#fff",
		border: "2px solid currentColor",
		marginTop: -8,
		marginLeft: -12,
		"&:focus, &:hover, &$active": {
			boxShadow: "inherit"
		}
	},
	active: {},
	valueLabel: {
		left: "calc(-50% + 4px)"
	},
	track: {
		height: 8,
		borderRadius: 4
	},
	rail: {
		height: 8,
		borderRadius: 4
	}
})(Slider);

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const EditAnnouncements = () => {
	const navigate = useNavigate();
	const { setDashboardHeader } = useContext(UIContext);
	const [announcement, setAnnouncement] = useState<any>();
	const [hasAnnouncementChanged, setHasAnnouncementChanged] = useState(false);
	const [isButtonSelected, setIsButtonSelected] = useState(true);
	const [isNewAnnouncement, setIsNewAnnouncement] = useState<boolean | null>(false);
	const [isValidAnnouncementId, setIsValidAnnouncementId] = useState(false);
	const [openColorPicker, setOpenColorPicker] = useState<string | null>(null);
	const isEmployerRoute = useEmployerRoute();
	const queryGroupNumber = useRouteParam("gn");
	const [validation, setValidation] = useState<Validation>();
	const [isFetched, setIsFetched] = useState<boolean>(false);
	const _validation = useRef<Validation>();
	const [assignedGroups, setAssignedGroups] = useState([]);
	const { user } = useContext(AuthContext);
	const [groupOptions, setGroupOptions] = useState<any>([]);
	const [groupName, setGroupName] = useState<any>();
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const anchorRef = useRef<any>(null);
	const textAlignOptions = useRef([
		{
			value: "Left",
			label: "Left"
		},
		{
			value: "Center",
			label: "Center"
		},
		{
			value: "Right",
			label: "Right"
		}
	]);
	const query = useQuery();

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleValidation = async () => {
		const { image, to_date, from_date, subject, description, text_align, group_number } = announcement;

		_validation.current = {
			subject: {},
			description: {},
			status: "invalid"
		};
		let flag = true;

		if (!group_number) {
			_validation.current["group_number"] = "group_number is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (subject.enabled === true) {
			if (subject.caption.length === 0) {
				_validation.current["subject"]["caption"] = "Caption is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}

		if (description.enabled === true) {
			if (description.caption.length === 0) {
				_validation.current["description"]["caption"] = "Caption is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}

		if (!text_align || text_align.length === 0) {
			_validation.current["text_align"] = "Text Alignment is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (from_date.length === 0) {
			_validation.current["from_date"] = "From Date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (to_date.length === 0) {
			_validation.current["to_date"] = "To Date is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (String(to_date).length !== 0) {
			const fromDate = new Date(from_date).getTime();
			const toDate = new Date(to_date).getTime();
			if (fromDate > toDate) {
				_validation.current["to_date"] = "To Date cannot be less than from date";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}

		if (image === null) {
			_validation.current["image"] = "Image is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (image === "") {
			_validation.current["image"] = "Image is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}

		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	};

	const handleDeleteImage = useCallback(() => {
		const _announcement = {
			...announcement,
			image: null
		};
		setAnnouncement(Object.assign({}, _announcement));
		setHasAnnouncementChanged(true);
	}, [announcement]);

	const handleFileChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { files } = event.target;
			if (files) {
				const _announcement = {
					...announcement,
					image: files[0],
					filename: files[0].name
				};
				setAnnouncement(Object.assign({}, _announcement));
				setIsFetched(false);
				event.target.value = "";
				setHasAnnouncementChanged(true);
			}
			//setFileInput(fileInput => ({ ...fileInput, [name]: files[0] }))
		},
		[announcement]
	);

	const handleAlignmentChange = useCallback(
		(
			event: React.ChangeEvent<{
				name?: string | undefined;
				value: unknown;
			}>
		) => {
			const { value } = event.target;
			const _announcement = {
				...announcement,
				text_align: value
			};
			setHasAnnouncementChanged(true);
			setAnnouncement(Object.assign({}, _announcement));
		},
		[announcement]
	);

	const handleChangeGroup = useCallback(
		(
			event: React.ChangeEvent<{
				name?: string | undefined;
				value: unknown;
			}>
		) => {
			const { value } = event.target;
			const _announcement = {
				...announcement,
				group_number: value
			};
			setHasAnnouncementChanged(true);
			setAnnouncement(Object.assign({}, _announcement));
		},
		[announcement]
	);

	const handleFromDateChange = useCallback(
		(date: MaterialUiPickersDate) => {
			const fromDate = new Date(date as Date);
			const parsedDate = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
			//fromDate = fromDate.getTime();
			const _announcement = {
				...announcement,
				from_date: parsedDate
			};
			setAnnouncement(Object.assign({}, _announcement));
			setHasAnnouncementChanged(true);
		},
		[announcement]
	);

	const handleToDateChange = useCallback(
		(date: MaterialUiPickersDate) => {
			const toDate = new Date(date as Date);
			const parsedDate = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
			//toDate = toDate.getTime();
			const _announcement = {
				...announcement,
				to_date: parsedDate
			};
			setAnnouncement(Object.assign({}, _announcement));
			setHasAnnouncementChanged(true);
		},
		[announcement]
	);

	const handleOpacityChange = useCallback(
		// eslint-disable-next-line @typescript-eslint/ban-types
		(event: React.ChangeEvent<{}>, newValue: number | number[]) => {
			const _announcement = {
				...announcement,
				opacity: newValue
			};
			setAnnouncement(Object.assign({}, _announcement));
			setHasAnnouncementChanged(true);
		},
		[announcement]
	);

	const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
		if (anchorRef.current && anchorRef?.current?.contains(event.target as any)) return;
		setOpenColorPicker(null);
	};

	const handleToggle = (name: string) => setOpenColorPicker(name);

	const handleColorChange = useCallback(
		(color: any, event: any, name: any, parent: any | null = null) => {
			if (!parent) {
				setAnnouncement(
					Object.assign({}, announcement, {
						[name]: color.hex
					})
				);
				return;
			}
			const _announcement = announcement;
			if (parent) {
				_announcement[parent] = Object.assign({}, _announcement[parent], {
					[name]: color.hex
				});
				setAnnouncement(Object.assign({}, _announcement));
				setHasAnnouncementChanged(true);
			}
		},
		[announcement]
	);

	const handleColorChangeComplete = useCallback(
		(color: any, event: any, name: any, parent: any | null = null) => {
			if (!parent) {
				setAnnouncement(
					Object.assign({}, announcement, {
						[name]: color.hex
					})
				);
				return;
			}
			const _announcement = announcement;
			if (parent) {
				_announcement[parent] = Object.assign({}, _announcement[parent], {
					[name]: color.hex
				});
				setAnnouncement(Object.assign({}, _announcement));
				setHasAnnouncementChanged(true);
			}
		},
		[announcement]
	);

	//checked={announcement?.subject.enabled}

	const handleEnableCheckboxClick = (event: any) => {
		const { name, checked } = event.target;
		// console.log("checked", checked);
		const _announcement = announcement;
		_announcement[name].enabled = checked;
		setAnnouncement(Object.assign({}, _announcement));
		setHasAnnouncementChanged(true);
	};

	const handleDownloadFile = (file: any) => {
		isFetched ? downloadFileFromMongoDB(file) : downloadFile(file);
	};

	const handleSubjectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setAnnouncement(
			Object.assign({}, announcement, {
				...announcement,
				subject: {
					...announcement.subject,
					caption: value
				}
			})
		);
		setHasAnnouncementChanged(true);
	};

	const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setAnnouncement(
			Object.assign({}, announcement, {
				...announcement,
				description: {
					...announcement.description,
					caption: value
				}
			})
		);
		setHasAnnouncementChanged(true);
	};

	const handleSaveClick = useCallback(async () => {
		const status = await handleValidation();
		if (status === "valid") {
			setIsButtonSelected(false);
			if (!hasAnnouncementChanged) {
				const pathname =
					isEmployerRoute === true && queryGroupNumber !== null
						? "/employer/settings/announcements"
						: "/settings/announcements";
				navigate(pathname);
				return;
			}
			const formData = new FormData();
			formData.append(
				"announcement",
				JSON.stringify({
					...announcement,
					opacity: announcement.opacity.toString()
				})
			);
			formData.append("image", announcement.image);
			let _announcement = null;
			if (isNewAnnouncement) {
				_announcement = await trackPromise(api.announcements.addAnnouncement(formData));
				setAnnouncement(Object.assign({}, _announcement));
				alert("Announcement is successfully Created!");
				navigate(-1);
			} else {
				_announcement = await trackPromise(api.announcements.editAnnouncement(formData));
				setAnnouncement(Object.assign({}, _announcement));
				alert("Announcement is successfully Edited!");
				navigate(-1);
			}
		}
	}, [
		announcement,
		handleValidation,
		hasAnnouncementChanged,
		isEmployerRoute,
		isNewAnnouncement,
		navigate,
		queryGroupNumber
	]);

	const handleAssignClick = useCallback(async () => {
		const status = await handleValidation();
		if (status === "valid") {
			setIsButtonSelected(false);
			const formData = new FormData();
			formData.append("announcement", JSON.stringify(announcement));
			formData.append("image", announcement.image);
			let _announcement: any | null = null;
			if (isNewAnnouncement) {
				_announcement = await trackPromise(api.announcements.addAnnouncement(formData));
				setAnnouncement(Object.assign({}, _announcement));
			} else {
				_announcement = await trackPromise(api.announcements.editAnnouncement(formData));
				setAnnouncement(Object.assign({}, _announcement));
			}

			if (_announcement) {
				setSnackbarAPICallProps(
					Object.assign({}, snackbarAPICallProps, {
						open: true,
						message: "Successfully saved announcement information",
						severity: "success"
					})
				);

				setTimeout(() => {
					const pathname =
						isEmployerRoute === true && queryGroupNumber !== null
							? `/employer/settings/announcement/assign-groups?id=${_announcement._id}&&gn=${queryGroupNumber}`
							: `/settings/announcement/assign-groups?id=${_announcement._id}`;
					navigate(pathname);
				}, 2000);
			}
		}
	}, [
		announcement,
		handleValidation,
		isEmployerRoute,
		isNewAnnouncement,
		navigate,
		queryGroupNumber,
		snackbarAPICallProps
	]);

	const getAnnouncementById = useCallback(
		async (id: string) => {
			const response = await trackPromise(api.announcements.getAnnouncementById(id));
			//chnage state
			setIsFetched(true);
			if (response) {
				let { from_date, to_date } = response;
				from_date = dateTimeZoneConverter(from_date as string) as string;
				to_date = dateTimeZoneConverter(to_date as string) as string;

				const payload = {
					...response,
					from_date,
					to_date
				};
				setAnnouncement(Object.assign({}, payload) as string);
				setIsValidAnnouncementId(true);
			}
		},
		[query]
	);

	const getAssignGroups = useCallback(async () => {
		const params = {
			user_id: user?._id
		};
		const response = await api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params);

		if (response) {
			const _assignedGroups: any[] = [];
			response.groupsAndLocations.forEach((group: any) => {
				if (group.assigned_group_info) {
					_assignedGroups.push(group);
				}
			});

			setAssignedGroups(Object.assign([], _assignedGroups));
		}
	}, [user?._id]);

	useEffect(() => {
		if (assignedGroups.length > 0) {
			const assignedGroup = assignedGroups.map((group: any) => ({
				value: `${group.group_number}`,
				label: `${group.name}-${group.group_number}`
			}));
			const assignGroupName = assignedGroups.find((group: any) => group.group_number === queryGroupNumber);
			if (assignGroupName) {
				const { name, group_number } = assignGroupName;
				setGroupName([`${name}-${group_number}`, group_number]);
				setAnnouncement(Object.assign({}, announcement, { group_number: group_number }));
				// debugger;
				// console.log("name&number", name, group_number);
			}
			setGroupOptions(assignedGroup);
		}
	}, [assignedGroups, queryGroupNumber]);

	// console.log("group", groupOptions, assignedGroups);

	useEffect(() => {
		if (query) {
			const newQueryValue = query.get("new");
			const _isNewAnnouncement = newQueryValue === "true" ? true : newQueryValue === "false" ? false : null;

			if (_isNewAnnouncement === false && query.get("id") !== null) {
				// Edit existing announcement
				getAnnouncementById(query.get("id") as string);
			} else if (_isNewAnnouncement === true) {
				// Add new announcement
				setAnnouncement({
					group_number: null,
					image: null,
					opacity: 2,
					to_date: "",
					from_date: "",
					subject: {
						caption: "",
						color: "#ffffff",
						enabled: false
					},
					description: {
						caption: "",
						color: "#ffffff",
						enabled: false
					},
					text_align: "",
					enabled: false
				});
				setIsValidAnnouncementId(true);
			}

			setIsNewAnnouncement(_isNewAnnouncement);

			// Update dashboard header based on the "new" parameter
			if (_isNewAnnouncement === true) {
				setDashboardHeader(ADMIN_DASHBOARD_HEADER.add_announcements);
			} else if (_isNewAnnouncement === false) {
				setDashboardHeader(ADMIN_DASHBOARD_HEADER.edit_announcements);
			}
		}
		getAssignGroups();
	}, [getAssignGroups, getAnnouncementById, query, setDashboardHeader]);

	// console.log("Announcement", announcement);
	// console.log("IsButtonSelected", isButtonSelected);

	return (
		<div className="edit-announcements" id="edit-announcements">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>
			{isValidAnnouncementId ? (
				<>
					<div className="group-assign-action-button-container" id="group-assign-action-button-container">
						<Button
							className="button-green"
							onClick={handleAssignClick}
							variant="contained"
							disabled={!isButtonSelected}
							disableElevation={!isButtonSelected}
							style={{
								cursor: !isButtonSelected ? "not-allowed" : "pointer",
								pointerEvents: "unset"
							}}
						>
							<span className="button-label-with-icon">Assign Locations</span>
							<span>
								<PeopleAltIcon className="button-icon" />
							</span>
						</Button>
						<Button
							className="button-black"
							onClick={handleSaveClick}
							variant="contained"
							disabled={!isButtonSelected}
							disableElevation={!isButtonSelected}
							style={{
								cursor: !isButtonSelected ? "not-allowed" : "pointer",
								pointerEvents: "unset"
							}}
						>
							<span className="button-label-with-icon">Save</span>
							<span>
								<SaveIcon className="button-icon" />
							</span>
						</Button>
					</div>
					<Grid container spacing={1} className="edit-announcement-container">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="subject">
							<div className="title">Group</div>
							<Suspense fallback={<div />}>
								<Paper className="paper-container" variant="outlined">
									<div className="caption-alignment" id="caption-alignment">
										<Grid container spacing={1}>
											<Grid item className="" xs={3} sm={3} md={3} lg={3} xl={3}>
												<div className="label-text">
													{/* <span>
                                                <ArrowForwardIosIcon style={{
                                                    fontSize: "0.9rem",
                                                    paddingTop: 4
                                                }}
                                                />
                                            </span> */}
													Group:
												</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="alignment-options">
												<Select
													id="group-select"
													name="group"
													value={
														queryGroupNumber
															? groupName
																? groupName[1]
																: null
															: announcement && announcement.group_number
													}
													label={
														queryGroupNumber
															? groupName
																? groupName[0]
																: null
															: announcement && announcement.groupOptions
													}
													disabled={queryGroupNumber ? true : false}
													onChange={handleChangeGroup}
													style={{
														cursor: !isButtonSelected ? "not-allowed" : "pointer",
														pointerEvents: "unset",
														minWidth: 180,
														textAlign: "left",
														zIndex: 10000,
														overflowY: "visible"
													}}
													MenuProps={{
														style: { zIndex: 35960 }
													}}
													inputProps={{ "aria-label": "Without label" }}
												>
													<MenuItem value="" disabled>
														Select Alignment
													</MenuItem>
													{groupOptions.map((option: any) => (
														<MenuItem key={option.value} value={option.value}>
															{option.label}
															{/* {console.log(option)} */}
														</MenuItem>
													))}
												</Select>
												{validation && validation.group_number ? (
													<div
														className="details"
														// style={{ paddingLeft: "12.7" }}
													>
														<span className="select-validation-text2">
															{validation.group_number}
														</span>
													</div>
												) : null}
											</Grid>
										</Grid>
									</div>
								</Paper>
							</Suspense>
						</Grid>
						<div className="title">Image & Opacity</div>
						<Suspense fallback={<div />}>
							<Paper className="paper-container" elevation={3} variant="outlined">
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<Grid container spacing={1}>
										<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
											<div className="label-text" id="label-text">
												{/* <span>
                                            <ArrowForwardIosIcon style={{
                                                fontSize: "0.9rem",
                                                paddingTop: 4
                                            }}
                                            />
                                        </span> */}
												Slider Image:
											</div>
										</Grid>
										<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="image-upload">
											<input
												className="image-upload-input"
												id="image-upload-input"
												name="image"
												type="file"
												onChange={handleFileChange}
												style={{ display: "none" }}
												accept="image/*"
											/>
											<label htmlFor="image-upload-input">
												<Button
													className="button-black"
													component="span"
													variant="contained"
													disabled={!isButtonSelected}
													disableElevation={!isButtonSelected}
													style={{
														cursor: !isButtonSelected ? "not-allowed" : "pointer",
														pointerEvents: "unset"
													}}
												>
													<span className="button-label-with-icon" style={{ color: "#ffff" }}>
														Change Image
													</span>
													<span>
														<PublishIcon
															className="button-icon"
															style={{ color: "#ffff" }}
														/>
													</span>
												</Button>
												{validation && validation.image !== undefined && validation.image ? (
													<div className="details" style={{ paddingLeft: "12.7" }}>
														<span className="select-validation-text">
															{validation.image}
														</span>
													</div>
												) : null}
											</label>
											{announcement && announcement.image ? (
												<div className="chip-container">
													<Tooltip title="Click to download" arrow>
														<Chip
															component="button"
															label={
																announcement.image.originalname
																	? announcement.image.originalname
																	: announcement.image.name
															}
															name="image"
															onDelete={() => handleDeleteImage()}
															onClick={() => {
																handleDownloadFile(announcement.image);
															}}
															disabled={!isButtonSelected}
															style={{
																cursor: !isButtonSelected ? "not-allowed" : "pointer",
																pointerEvents: "unset"
															}}
														/>
													</Tooltip>
												</div>
											) : null}
										</Grid>
									</Grid>
								</Grid>
								<Divider className="screen-divider" />
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="opacity-container">
									<Grid container spacing={1}>
										<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
											<div className="label-text" id="label-text">
												{/* <span>
                                            <ArrowForwardIosIcon style={{
                                                fontSize: "0.9rem",
                                                paddingTop: 4
                                            }}
                                            />
                                        </span> */}
												Image Opacity:
											</div>
										</Grid>
										<Grid item xl={9} lg={9} md={9} sm={9} xs={9}>
											<div>
												Opacity
												<PrettoSlider
													value={announcement && announcement.opacity}
													onChange={(event, newValue) => handleOpacityChange(event, newValue)}
													valueLabelDisplay="on"
													aria-label="pretto slider"
													defaultValue={20}
													valueLabelFormat={(value) => <div>{value + "px"}</div>}
													style={{
														cursor: !isButtonSelected ? "not-allowed" : "pointer",
														pointerEvents: "unset"
													}}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
							</Paper>
						</Suspense>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="date">
							<div className="title">Date Range</div>
							<Suspense fallback={<div />}>
								<Paper className="paper-container" variant="outlined">
									<Grid container spacing={1} className="form-label">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="label-text" id="label-text">
												{/* <span>
                                            <ArrowForwardIosIcon style={{
                                                fontSize: "0.9rem",
                                                paddingTop: 4
                                            }}
                                            />
                                        </span> */}
												From Date:
											</div>
										</Grid>
										<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
											<div className="date-picker">
												<MuiPickersUtilsProvider utils={DateFnsUtils}>
													<KeyboardDatePicker
														className="from-date-input"
														inputVariant="outlined"
														label="From Date"
														placeholder="From Date"
														id="from-date-input"
														name="from_date"
														format="MM/dd/yyyy"
														error={false}
														value={announcement && announcement.from_date}
														onChange={handleFromDateChange}
														InputProps={{
															readOnly: true
														}}
														InputLabelProps={{
															shrink: true
														}}
														//style={{ width: "340px", borderRadius: 50 }}
														keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
														KeyboardButtonProps={{
															"aria-label": "change date"
														}}
														disabled={!isButtonSelected}
														style={{
															cursor: !isButtonSelected ? "not-allowed" : "pointer",
															pointerEvents: "unset",
															width: "340px",
															borderRadius: 50
														}}
														helperText={
															validation && validation.from_date
																? validation.from_date
																: null
														}
													/>
												</MuiPickersUtilsProvider>
											</div>
										</Grid>
									</Grid>
									<Divider className="screen-divider" />
									<Grid container spacing={1} className="form-label-margin-2px">
										<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
											<div className="label-text" id="label-text">
												{/* <span>
                                            <ArrowForwardIosIcon style={{
                                                fontSize: "0.9rem",
                                                paddingTop: 4
                                            }}
                                            />
                                        </span> */}
												To Date:
											</div>
										</Grid>
										<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
											<div className="date-picker">
												<MuiPickersUtilsProvider utils={DateFnsUtils}>
													<KeyboardDatePicker
														className="to-date-input"
														inputVariant="outlined"
														label="To Date"
														placeholder="To Date"
														id="to-date-input"
														name="to_date"
														format="MM/dd/yyyy"
														error={false}
														value={announcement && announcement.to_date}
														onChange={handleToDateChange}
														InputProps={{
															readOnly: true
														}}
														InputLabelProps={{
															shrink: true
														}}
														//style={{ width: "340px", borderRadius: 50 }}
														keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
														KeyboardButtonProps={{
															"aria-label": "change date"
														}}
														disabled={!isButtonSelected}
														style={{
															cursor: !isButtonSelected ? "not-allowed" : "pointer",
															pointerEvents: "unset",
															width: "340px",
															borderRadius: 50
														}}
														helperText={
															validation && validation.to_date ? validation.to_date : null
														}
													/>
												</MuiPickersUtilsProvider>
											</div>
										</Grid>
									</Grid>
								</Paper>
							</Suspense>
						</Grid>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="subject">
							<div className="title">Caption</div>
							<Suspense fallback={<div />}>
								<Paper className="paper-container" variant="outlined">
									<div className="caption-text" id="caption-text">
										Subject
									</div>
									<div className="subject-color-picker-container" style={{ marginTop: "1em" }}>
										<Grid container>
											<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
												<div className="label-text" id="label-text">
													Color:
												</div>
											</Grid>
											<Grid item xl={9} lg={9} md={9} sm={9} xs={9} className="subject-color">
												<ButtonGroup
													variant="contained"
													ref={anchorRef}
													aria-label="split button"
												>
													<Button
														className="theme-button"
														style={{
															backgroundColor:
																announcement &&
																announcement.subject &&
																announcement.subject.color,
															cursor: "default"
														}}
													></Button>
													<Button
														className="color-picker-button"
														size="small"
														variant="outlined"
														aria-controls={
															openColorPicker ? "split-button-menu" : undefined
														}
														aria-expanded={openColorPicker ? "true" : undefined}
														aria-label="select merge strategy"
														aria-haspopup="menu"
														onClick={() => handleToggle("subject")}
														disabled={!isButtonSelected}
														disableElevation={!isButtonSelected}
														style={{
															cursor: !isButtonSelected ? "not-allowed" : "pointer",
															pointerEvents: "unset"
														}}
													>
														Pick Color
													</Button>
												</ButtonGroup>
												<Popper
													className="popper-primary-color"
													open={openColorPicker === "subject"}
													anchorEl={anchorRef.current}
													role={undefined}
													transition
													disablePortal
												>
													{({ TransitionProps, placement }) => (
														<Grow
															{...TransitionProps}
															style={{
																transformOrigin:
																	placement === "bottom"
																		? "center top"
																		: "center bottom",
																zIndex: 2000
															}}
														>
															<ClickAwayListener onClickAway={handleClose}>
																<SketchPicker
																	className="sketch"
																	color={
																		announcement &&
																		announcement.subject &&
																		announcement.subject.color
																	}
																	onChangeComplete={(color, event) => {
																		handleColorChangeComplete(
																			color,
																			event,
																			"color",
																			"subject"
																		);
																	}}
																	onChange={(color, event) => {
																		handleColorChange(
																			color,
																			event,
																			"color",
																			"subject"
																		);
																	}}
																/>
															</ClickAwayListener>
														</Grow>
													)}
												</Popper>
											</Grid>
										</Grid>
									</div>
									<div className="subject-caption" id="subject-caption">
										<Grid container>
											<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
												<div className="label-text" id="label-text">
													{/* <span>
                                                <ArrowForwardIosIcon style={{
                                                    fontSize: "0.9rem",
                                                    paddingTop: 4
                                                }}
                                                />
                                            </span> */}
													Caption:
												</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
												<TextField
													className="subject-caption-input"
													id="subject-caption-input"
													name="caption"
													placeholder="Enter Subject Caption"
													value={
														announcement &&
														announcement.subject &&
														announcement.subject.caption
													}
													onChange={handleSubjectChange}
													variant="outlined"
													//style={{ width: "70%", borderRadius: 50 }}
													disabled={!isButtonSelected}
													style={{
														cursor: !isButtonSelected ? "not-allowed" : "pointer",
														pointerEvents: "unset",
														width: "70%",
														borderRadius: 50
													}}
													helperText={
														validation && validation.subject && validation.subject.caption
															? validation.subject.caption
															: null
													}
												/>
											</Grid>
										</Grid>
									</div>
									<div className="subject-enabled-checkbox" id="subject-enabled-checkbox">
										<span>
											<GreenCheckbox
												onChange={handleEnableCheckboxClick}
												name="subject"
												checked={
													announcement && announcement.subject && announcement.subject.enabled
												}
												disabled={!isButtonSelected}
												style={{
													cursor: !isButtonSelected ? "not-allowed" : "pointer",
													pointerEvents: "unset"
												}}
											/>
										</span>
										<span className="subject-enabled-text" id="subject-enabled-text">
											Enable Subject
										</span>
									</div>
									<Divider className="screen-divider" />
									<div className="caption-text" id="caption-text">
										Description
									</div>
									<div className="Description-color-picker-container" style={{ marginTop: "1em" }}>
										<Grid container>
											<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
												<div className="label-text" id="label-text">
													Color:
												</div>
											</Grid>
											<Grid item xl={9} lg={9} md={9} sm={9} xs={9} className="description-color">
												<ButtonGroup
													variant="contained"
													ref={anchorRef}
													aria-label="split button"
												>
													<Button
														className="theme-button"
														style={{
															backgroundColor:
																announcement &&
																announcement.description &&
																announcement.description.color,
															cursor: "default"
														}}
													></Button>
													<Button
														className="color-picker-button"
														size="small"
														variant="outlined"
														aria-controls={
															openColorPicker ? "split-button-menu" : undefined
														}
														aria-expanded={openColorPicker ? "true" : undefined}
														aria-label="select merge strategy"
														aria-haspopup="menu"
														onClick={() => handleToggle("description")}
														disabled={!isButtonSelected}
														disableElevation={!isButtonSelected}
														style={{
															cursor: !isButtonSelected ? "not-allowed" : "pointer",
															pointerEvents: "unset"
														}}
													>
														Pick Color
													</Button>
												</ButtonGroup>
												<Popper
													className="popper-primary-color"
													open={openColorPicker === "description"}
													anchorEl={anchorRef.current}
													role={undefined}
													transition
													disablePortal
												>
													{({ TransitionProps, placement }) => (
														<Grow
															{...TransitionProps}
															style={{
																transformOrigin:
																	placement === "bottom"
																		? "center top"
																		: "center bottom",
																zIndex: 2000
															}}
														>
															<ClickAwayListener onClickAway={handleClose}>
																<SketchPicker
																	className="sketch"
																	// id="2"
																	color={
																		announcement &&
																		announcement.description &&
																		announcement.description.color
																	}
																	onChangeComplete={(color, event) => {
																		handleColorChangeComplete(
																			color,
																			event,
																			"color",
																			"description"
																		);
																	}}
																	onChange={(color, event) => {
																		handleColorChange(
																			color,
																			event,
																			"color",
																			"description"
																		);
																	}}
																/>
															</ClickAwayListener>
														</Grow>
													)}
												</Popper>
											</Grid>
										</Grid>
									</div>
									<div className="description-caption" id="description-caption">
										<Grid container>
											<Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
												<div className="label-text" id="label-text">
													{/* <span>
                                                <ArrowForwardIosIcon style={{
                                                    fontSize: "0.9rem",
                                                    paddingTop: 4
                                                }}
                                                />
                                            </span> */}
													Caption:
												</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
												<TextField
													className="description-input"
													id="description-input"
													name="caption"
													placeholder="Enter Description"
													value={
														announcement &&
														announcement.description &&
														announcement.description.caption
													}
													onChange={handleDescriptionChange}
													variant="outlined"
													//style={{ width: "70%", borderRadius: 50 }}
													disabled={!isButtonSelected}
													style={{
														cursor: !isButtonSelected ? "not-allowed" : "pointer",
														pointerEvents: "unset",
														width: "70%",
														borderRadius: 50
													}}
													helperText={
														validation &&
														validation.description &&
														validation.description.caption
															? validation.description.caption
															: null
													}
												/>
											</Grid>
										</Grid>
									</div>
									<div className="description-enabled-checkbox" id="description-enabled-checkbox">
										<span>
											<GreenCheckbox
												onChange={handleEnableCheckboxClick}
												name="description"
												checked={
													announcement &&
													announcement.description &&
													announcement.description.enabled
												}
												disabled={!isButtonSelected}
												style={{
													cursor: !isButtonSelected ? "not-allowed" : "pointer",
													pointerEvents: "unset"
												}}
											/>
										</span>
										<span className="description-enabled-text" id="description-enabled-text">
											Enable Description
										</span>
									</div>
									<Divider className="screen-divider" />
									<div className="caption-text" id="caption-text">
										{/* <span>
                                    <ArrowForwardIosIcon style={{
                                        fontSize: "0.9rem",
                                        paddingTop: 4
                                    }}
                                    />
                                </span> */}
										Caption Alignment
									</div>
									<div className="caption-alignment" id="caption-alignment">
										<Grid container spacing={1}>
											<Grid item className="" xs={3} sm={3} md={3} lg={3} xl={3}>
												<div className="label-text">
													{/* <span>
                                                <ArrowForwardIosIcon style={{
                                                    fontSize: "0.9rem",
                                                    paddingTop: 4
                                                }}
                                                />
                                            </span> */}
													Text Align:
												</div>
											</Grid>
											<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="alignment-options">
												<Select
													id="text-align-options"
													name="text_align"
													value={announcement.text_align}
													onChange={handleAlignmentChange}
													disabled={!isButtonSelected}
													style={{
														cursor: !isButtonSelected ? "not-allowed" : "pointer",
														pointerEvents: "unset",
														minWidth: 180,
														textAlign: "left",
														zIndex: 10000,
														overflowY: "visible"
													}}
													MenuProps={{
														style: { zIndex: 35960 }
													}}
													inputProps={{ "aria-label": "Without label" }}
												>
													<MenuItem value="" disabled>
														Select Alignment
													</MenuItem>
													{textAlignOptions.current.map((option) => (
														<MenuItem key={option.value} value={option.value}>
															{option.label}
														</MenuItem>
													))}
												</Select>
												{validation?.text_align ? (
													<div
														className="details"
														// style={{ paddingLeft: "12.7" }}
													>
														<span className="select-validation-text2">
															{validation?.text_align}
														</span>
													</div>
												) : null}
											</Grid>
										</Grid>
									</div>
								</Paper>
							</Suspense>
						</Grid>
					</Grid>
				</>
			) : null}
		</div>
	);
};

export default EditAnnouncements;
